"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    CommonLibError: ()=>CommonLibError,
    tryCatch: ()=>tryCatch
});
class CommonLibError extends Error {
    constructor(module, message){
        super(`[CommonLib](${module}): ${message}`);
    }
}
function tryCatch(executor, onError) {
    try {
        return executor();
    } catch (error) {
        onError(error);
    }
}
exports.CommonLibError = __webpack_exports__.CommonLibError;
exports.tryCatch = __webpack_exports__.tryCatch;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "CommonLibError",
    "tryCatch"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
